import {
  UserDetailsProps,
  UserDetailsTableProps,
} from 'enums/UserDetailsEnums';
import React from 'react';
import styles from './UserDetails.module.scss';
import { ReactComponent as Delete } from 'assets/icons/delete.svg';
import { ReactComponent as Edit } from 'assets/icons/draft.svg';
import clsx from 'clsx';
import { ColumnGroupType } from 'antd/lib/table';
import { User } from 'models/User/User.model';
interface ColumnsProps {
  handleOpenEditModal: () => void;
  handleOpenDeleteModal: () => void;
}

export const getColumns = ({
  handleOpenEditModal,
  handleOpenDeleteModal,
}: ColumnsProps) => {
  return [
    {
      title: UserDetailsTableProps.NAME_TITLE,
      dataIndex: UserDetailsTableProps.NAME_DATA_INDEX,
    },
    {
      title: UserDetailsTableProps.ROLE_TITLE,
      dataIndex: UserDetailsTableProps.ROLE_INDEX,
      render: (value, record) => (
        <div className="text-capitalize">{value?.name}</div>
      ),
    },
    {
      title: UserDetailsTableProps.EMAIL_TITLE,
      dataIndex: UserDetailsTableProps.EMAIL_INDEX,
    },
    {
      title: UserDetailsTableProps.PHONE_TITLE,
      dataIndex: UserDetailsTableProps.PHONE_INDEX,
    },
    {
      title: UserDetailsTableProps.BRAND,
      dataIndex: UserDetailsTableProps.BRAND_INDEX,
      render: value => <p style={{ marginTop: '1px' }}>{value ?? '-'}</p>,
    },
    {
      title: UserDetailsTableProps.MFA_TITLE,
      dataIndex: UserDetailsTableProps.MFA_INDEX,
      ellipsis: false,
      width: '120px',
      render: (value: boolean | undefined, record: User) => {
        // Get value from record if not directly available
        const mfaValue = value !== undefined ? value : record?.mfaEnabled;
        const isEnabled = mfaValue === true;
        return (
          <div
            style={{
              color: isEnabled ? '#52c41a' : '#8c8c8c',
              display: 'inline-block',
              whiteSpace: 'nowrap'
            }}>
            {isEnabled ? 'Enabled' : 'Disabled'}
          </div>
        );
      },
    },
    {
      title: UserDetailsTableProps.ACTION_TITLE,
      width: UserDetailsTableProps.ACTION_WIDTH,
      align: 'right' as const,
      render: (_text: string, _: unknown, _index: number) => (
        <span className={styles.actionIconContainer}>
          <>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={handleOpenEditModal}>
              <Edit
                type={UserDetailsProps.EDIT_ICON_ALT}
                className={styles.editIcon}
              />
            </div>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={handleOpenDeleteModal}>
              <Delete
                type={UserDetailsProps.DELETE_ICON_ALT}
                className={styles.deleteIcon}
              />
            </div>
          </>
        </span>
      ),
    },
  ] as ColumnGroupType<User>[];
};
